import React from 'react';
import PropTypes from 'prop-types';
import './main.less';

class Submenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			topStyle: {
				top: -1
			}
		};
	}

	componentDidMount() {
		const subMenuOffsetTop = this.refs.submenu.getBoundingClientRect().top;
		const subMenuHeight = this.refs.submenu.getBoundingClientRect().height;
		const windowHeight = window.innerHeight;
		const submenuItemHeight = subMenuHeight / this.props.children.length;
		const difference = windowHeight - (subMenuOffsetTop + subMenuHeight);
		if (subMenuOffsetTop + subMenuHeight > windowHeight) {
			this.setState({
				topStyle: {
					top: (Math.ceil(difference / submenuItemHeight) * submenuItemHeight) - submenuItemHeight
				}
			});
		}
	}

	render() {
		return (<div ref="submenu" style={this.state.topStyle} className="main-menu__submenu">{this.props.children}</div>);
	}
}

Submenu.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};

export default Submenu;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/menu/submenu/main.js